import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import $ from 'jquery'
import ReactDOM from 'react-dom'
import createReactClass from 'create-react-class'
import { BranchMixin } from 'legacy/libs/baobab-react-mixins'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import { zoomMapToObj, getOverlaysFromWkt } from 'legacy/apps/region/utils'
import WktFactory from 'legacy/libs/wicket'
import { withGoogleMaps } from 'common/google-maps'

import s from './styles/gis-region.module.scss'

function modifyUndoButton(index) {
  // Delete button integration hack from old code
  const $btnUndo = $(
    "img[src$='https://maps.gstatic.com/mapfiles/undo_poly.png']"
  )
  $btnUndo.parent().parent().find(`.${s.deletePolyContainer}`).remove()
  $btnUndo.parent().css('height', '21px !important')
  $btnUndo
    .parent()
    .parent()
    .append(
      `<div class="${s.deletePolyContainer}">` +
        `<a class="${s.deletePoly}" />` +
        '</div>'
    )

  $btnUndo
    .parent()
    .parent()
    .find(`.${s.deletePoly}`)
    .hover(
      () => false,
      () => false
    )
    .mousedown(function () {
      $(this).css('background-position-x', '-60px')
      return false
    })
    .click(() => {
      this.removeAt(index)
      return false
    })
}

const Region = createReactClass({
  mixins: [BranchMixin, FormComponentMixin],

  propTypes: {
    maps: PropTypes.object.isRequired,
    wkt: PropTypes.string,
    onSync: PropTypes.func,
    mapConfig: PropTypes.object, // eslint-disable-line
    drawingConfig: PropTypes.object, // eslint-disable-line
    hideAdministrativeLines: PropTypes.bool,
    autoFitMap: PropTypes.bool,
    // The user can't edit/draw on the map if `readOnly` is set
    readOnly: PropTypes.bool,
    // The user can create new polygons if `drawable` is set
    drawable: PropTypes.bool,
    // The user can edit polygons if `editable` is true
    editable: PropTypes.bool,
  },

  cursors(props, context) {
    if (_.has(this.props, 'wkt')) {
      return {}
    }

    return {
      wkt: this.getCursor(props, context),
    }
  },

  getDefaultProps() {
    return {
      onSync: _.identity,
      mapConfig: {},
      drawingConfig: {},
      readOnly: false,
      autoFitMap: true,
      hideAdministrativeLines: false,
      drawable: true,
      editable: true,
    }
  },

  getInitialState() {
    if (_.has(this.props, 'wkt')) {
      return {
        wkt: this.props.wkt,
      }
    }

    return {}
  },

  googleMap: null,
  googleMapIdleListener: null,
  drawingManager: null,
  overlays: null,

  isDrawable(props) {
    const { readOnly, drawable } = props || this.props

    return !readOnly && drawable
  },

  isEditable(props) {
    const { readOnly, editable } = props || this.props

    return !readOnly && editable
  },

  clearMap() {
    this.removeOverlays()
    this.syncValue()
  },

  removeOverlays() {
    _.forEach(this.overlays, this.removeOverlay)
  },

  removeOverlay(overlay) {
    overlay.setMap(null)
    this.overlays = _.without(this.overlays, overlay)
  },

  addOverlay(overlay) {
    this.overlays.push(overlay)
  },

  syncValue() {
    const Wkt = WktFactory()
    const wicket = new Wkt()

    const newValue = _.isEmpty(this.overlays)
      ? null
      : wicket.fromObject(this.overlays).write()

    const prevValue = this.state.wkt

    if (newValue === prevValue) {
      return
    }

    this.setValue(newValue, () => {
      this.setDirtyState()
      this.props.onSync(newValue, prevValue)
    })
  },

  fitMap() {
    zoomMapToObj(this.googleMap, this.overlays)
  },

  createMap() {
    const mapConfig = _.merge(
      {
        zoom: 2,
        center: new this.props.maps.LatLng(0, 0),
        streetViewControl: false,
        disableDefaultUI: false,
        draggable: true,
        scrollwheel: true,
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: this.props.maps.ControlPosition.TOP_LEFT,
          style: this.props.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain'],
        },
      },
      this.props.mapConfig
    )

    return new this.props.maps.Map(ReactDOM.findDOMNode(this), mapConfig)
  },

  setStyledMap() {
    const styledMap = new this.props.maps.StyledMapType([
      {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }],
      },
    ])

    this.googleMap.mapTypes.set('noDateLineMap', styledMap)
    this.googleMap.setMapTypeId('noDateLineMap')
  },

  initializeDrawingManager() {
    this.drawingManager = new this.props.maps.drawing.DrawingManager({
      polygonOptions: this.getDrawingConfig(this.props.drawingConfig),
    })

    this.props.maps.event.addListener(
      this.drawingManager,
      'overlaycomplete',
      (event) => {
        const overlay = event.overlay

        this.addOverlay(overlay)
        if (this.isEditable()) {
          this.setOverlayEditable(overlay)
        }

        this.syncValue()
      }
    )

    this.drawingManager.setMap(this.googleMap)
  },

  setOverlayEditable(overlay) {
    overlay.setEditable(true)

    const overlayPath = overlay.getPath()

    // Catch right click for point removing
    this.props.maps.event.addListener(overlay, 'rightclick', (mev) => {
      if (mev.vertex != null) {
        overlayPath.removeAt(mev.vertex)
      }
    })

    // Catch point removing
    this.props.maps.event.addListener(overlayPath, 'remove_at', () => {
      if (overlayPath.length === 1) {
        this.removeOverlay(overlay)
      }

      this.syncValue()
    })

    // Catch white dots move
    this.props.maps.event.addListener(overlayPath, 'set_at', modifyUndoButton)
    this.props.maps.event.addListener(overlayPath, 'set_at', () =>
      this.syncValue()
    )

    // Catch grey dots move
    this.props.maps.event.addListener(
      overlayPath,
      'insert_at',
      modifyUndoButton
    )
    this.props.maps.event.addListener(overlayPath, 'insert_at', () =>
      this.syncValue()
    )
  },

  getDrawingConfig(userDrawingConfig) {
    return {
      strokeColor: '#3c8cb5',
      fillColor: '#3c8cb5',
      fillOpacity: 0.3,
      strokeWeight: 3,

      ...userDrawingConfig,
    }
  },

  drawOverlay(overlay) {
    if (!this.props.readOnly) {
      this.setOverlayEditable(overlay)
    }

    overlay.setMap(this.googleMap)
  },

  drawOverlaysFromWkt(wkt, drawingConfig) {
    const rawOverlays = getOverlaysFromWkt(
      wkt,
      this.getDrawingConfig(drawingConfig)
    )

    const overlays = _.isArray(rawOverlays) ? rawOverlays : [rawOverlays]
    _.forEach(overlays, this.drawOverlay)

    return overlays
  },

  redraw(props, state) {
    const { drawingConfig, autoFitMap } = props || this.props
    const { wkt } = state || this.state

    this.removeOverlays()
    this.overlays = this.drawOverlaysFromWkt(wkt, drawingConfig)

    if (autoFitMap) {
      this.fitMap()
    }
  },

  componentDidMount() {
    this.googleMap = this.createMap()
    this.overlays = this.drawOverlaysFromWkt(
      this.state.wkt,
      this.props.drawingConfig
    )

    if (this.props.hideAdministrativeLines) {
      this.setStyledMap()
    }

    // When map rendered within hidden container it neccesarry
    // to force its rendering using this trick.
    // Without this trick map doesn't gets rendered in the EditRegionForm
    this.googleMapIdleListener = this.props.maps.event.addListenerOnce(
      this.googleMap,
      'idle',
      () => {
        this.props.maps.event.trigger(this.googleMap, 'resize')

        if (this.props.autoFitMap) {
          this.fitMap()
        }
      }
    )

    if (!this.props.readOnly) {
      this.initializeDrawingManager()
    }
  },

  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    if (this.drawingManager) {
      if (!this.isDrawable(nextProps)) {
        this.drawingManager.setOptions({
          drawingMode: null,
          drawingControlOptions: {
            position: this.props.maps.ControlPosition.TOP_CENTER,
            drawingModes: [],
          },
        })
      } else {
        this.drawingManager.setOptions({
          drawingControlOptions: {
            position: this.props.maps.ControlPosition.TOP_CENTER,
            drawingModes: [this.props.maps.drawing.OverlayType.POLYGON],
          },
        })
      }
    }

    if (nextProps.wkt !== this.props.wkt) {
      this.setState({ wkt: nextProps.wkt })
    }
  },

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (!this.props.readOnly) {
      // Handle only map clearing
      if (!nextState.wkt) {
        this.clearMap()
      }

      // Doesn't override wkt when map is editable
      return
    }

    if (_.isEqual(nextState, this.state) && _.isEqual(nextProps, this.props)) {
      return
    }

    this.redraw(nextProps, nextState)
  },

  componentWillUnmount() {
    this.props.maps.event.removeListener(this.googleMapIdleListener)
    this.removeOverlays()
    this.googleMap = null
  },

  render() {
    return <div style={{ width: '100%', height: '100%' }} />
  },
})

export default withGoogleMaps(Region)
